module.exports = "/assets/data/2c1b978bd450874c1f928d698f196e47-RG41.data.json";